import PageHeader from "@/components/PageHeader";
import MyDate from "@/sections/MyDate";
import Trust from "@/sections/Trust";

export default function MyDatePage() {
  return (
    <>
      <PageHeader silk={1}
        testid="my-date-header"
        rose
        eyebrow="My Date"
        titleLines={["Tek bir istek,", "karşılıklı bir başlangıç."]}
        lede="My Date, ilgilendiğin kişiye gönderdiğin zarif bir ilgi isteğidir. İlgi karşılıklı olduğunda ikinize özel eşleşme alanınız açılır."
      />
      <MyDate showLink={false} />
      <Trust />
    </>
  );
}
